import { render, staticRenderFns } from "./MakeSoccerPredictions.vue?vue&type=template&id=13c19f27&scoped=true&"
import script from "./MakeSoccerPredictions.vue?vue&type=script&lang=js&"
export * from "./MakeSoccerPredictions.vue?vue&type=script&lang=js&"
import style0 from "./MakeSoccerPredictions.vue?vue&type=style&index=0&id=13c19f27&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c19f27",
  null
  
)

export default component.exports